import React, { useEffect, useState } from "react";
import { CustomerViewDetailsViewCampaignsInfoProps } from "./customer-view-details-view-campaigns-info.props";
import "./customer-view-details-view-campaigns-info.scss";
import AddToCampaignModal from "../../../../lead-actions/add-new-campaign/add-new-campiagn";
import CampaignTable from "../../../../../../common/components/modal-table/modal-table";
import { getCustomerDetails } from "../../../../../../api/customer";

const CustomerViewDetailsViewCampaignsInfo: React.FC<
  CustomerViewDetailsViewCampaignsInfoProps
> = (props: any) => {
  const {
    allCustomerData,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    disableEdit
  } = props;

  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);
  const [campiagnDetails, setCampaignDetails] = useState<any>(null);
  const [customerName, setCustomerName] = useState("");

  const fetchCustomerDetails = async () => {
    setLoading(true);
    try {
      const response = await getCustomerDetails(allCustomerData);
      const customerData = response?.data?.data;
      setCustomerName(`${customerData?.first_name || ""} ${customerData?.middle_name || ""} ${customerData?.last_name || ""}`);
      setCampaignDetails(
        (response?.data?.data?.campaigns || []).map((item: any) => ({
          ...item,
          start_date: item?.startDate,
          end_date: item?.endDate,
          membership_status: item.memberStatus,
          campaign_customer_association_id: item.id,
        }))
      );
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead."
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCustomerDetails();
  }, [allCustomerData]);

  return (
    <div className="customer-view-details-view-campaigns-info">
      <div className="customer-view-details-view-campaigns-info-header">
        <div className="customer-view-details-view-campaigns-info-header-text">
          Campaigns
        </div>
      </div>

      <div className="customer-view-details-view-campaigns-info-no-data">
        {campiagnDetails && campiagnDetails.length > 0 ? (
          <CampaignTable
            data={campiagnDetails}
            isCustomer={true}
          />
        ) : (
          <div className="no-record-text">No Record Found</div>
        )}
      </div>

      <AddToCampaignModal
        customerIds={[allCustomerData]}
        isOpen={isCampaignModalOpen}
        setMenuItems={() => {}}
        selectedActions={"addToCampaign"}
        handleMassActionMenuClose={() => setIsCampaignModalOpen(false)}
        multipleCampaign={true}
        onSave={() => {
          fetchCustomerDetails();
          setIsCampaignModalOpen(false);
        }}
      />
    </div>
  );
};

export default CustomerViewDetailsViewCampaignsInfo;
